module.exports = __webpack_public_path__ + "da661ea52bcfc76415351f3fb0e83ed7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/broadcom_2022_chart.png
// module id = 1644
// module chunks = 0